export default class DadosOutorganteModel {
    constructor(public razao: string,
                public responsavel: string,
                public cpf: number, 
                public perfil: string,             
                public validade: string,
                public inscricao: string){}
}
